import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["onClick", "aria-selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "lp-filter",
    role: "listbox",
    "aria-label": _ctx.Filters
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("button", {
        type: "button",
        class: _normalizeClass(["lp-filter__item", [option.ColorClass, { active: option.Selected }]]),
        key: `filter-${index}`,
        style: _normalizeStyle([option.Selected ? 
                            {
                                'background-color': option.BackgroundColor,
                                'border-color': option.BackgroundColor
                            } : {
                                'background-color': 'transparent', 
                                'border-color': option.BackgroundColor
                            }
                        ]),
        onClick: ($event: any) => (_ctx.optionClickedHandler(option)),
        role: "option",
        "aria-selected": option.Selected
      }, _toDisplayString(option.Title), 15, _hoisted_2))
    }), 128))
  ], 8, _hoisted_1))
}